import React from "react";

import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import ButtonX from "../Images/ButtonX.svg";

export default function ModalConsumoMinimo({
  isOpen,
  onRequestClose,
  recipient = "Usuario A",
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
      style={{ outline: 0 }}
      ariaHideApp={false}
      className={{
        base: "modal-base",
        afterOpen: "modal-base_after-open",
        beforeClose: "modal-base_before-close",
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close",
      }}
      shouldCloseOnOverlayClick={true}
    >
      <div className="imgX" id="btnXModalGPCR" onClick={onRequestClose}>
        <img alt={""} src={ButtonX}></img>
      </div>

      <div className="modal-body-redefinir">
        <p className="modal-text">
          No momento estamos ofertando nossos serviços apenas para residências e
          empresas em{" "}
          <b>Goiás, Mato Grosso, Minas Gerais, Paraná, e São Paulo</b>.
        </p>
      </div>
    </Modal>
  );
}
